import { useEffect } from 'react'
import * as chatStore from '../stores'
import { getConfig } from '@packages/config'
import { BaseChatPackage } from '../utils'

export class UseClientConfig extends BaseChatPackage {
  useClientConfig({ enabled }: { enabled: boolean }) {
    const user = chatStore.useUser()
    useEffect(() => {
      if (enabled) {
        this.chatApi.createUser().then(response => {
          if (response.ok) {
            chatStore.setUser(response.data)
          }
        })
      }
    }, [enabled])

    const config = getConfig().use()

    if (!user?.id) return null

    return {
      apiKey: config.values.chatApiKey,
      tokenOrProvider: user.access_token,
      userData: {
        id: user.id,
        name: user.name,
      },
    }
  }
}